/* eslint-disable react/prop-types */
import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DescriptionIcon from '@mui/icons-material/Description';
import DetailsIcon from '@mui/icons-material/Details';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import makeStyles from '@mui/styles/makeStyles';
import useRouter from 'hooks/useRouter';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: theme.spacing(2),
    marginLeft: theme.spacing(2),
    color: theme.palette.text.grey,
    fontFamily: theme.fonts.openSans,
    padding: theme.spacing(1)
  },
  details: {
    fontSize: 16,
    color: '#000',
    fontFamily: theme.fonts.openSans,
    padding: theme.spacing(1),
    cursor: 'pointer',
    '&:hover': {
      opacity: '0.8'
    }
  },
  drawerPaper: {
    overflowY: 'auto',
    width: '200px',
    top: 'unset',
    backgroundColor: '#3379FF2B',
    '& .Mui-selected': {
      backgroundColor: '#FFF',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.3)'
      }
    }
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3)
  },
  light: {
    backgroundColor: '#555'
  },
  black: {
    color: theme.palette.common.black
  },
  itemIcon: {
    minWidth: 50,
    marginLeft: 12
  }
}));

const TenantSidebar = () => {
  const classes = useStyles();
  const router = useRouter();
  const { data: assetDetails } = useSelector((state) => state.assets.assetDetails);
  const { id } = router.query;
  const { tab } = router.match.params;
  const { state } = router.location;

  return (
    <Drawer
      variant="permanent"
      anchor="left"
      classes={{
        paper: classes.drawerPaper
      }}
      style={{ height: '100%', width: '200px' }}
    >
      <List>
        <ListItemButton
          className={classes.details}
          component={RouterLink}
          to={{
            pathname: `/Asset/${assetDetails?.id}/${state?.from || 'Details'}`,
            state: { from: state?.from }
          }}
        >
          <ListItemIcon className={classes.itemIcon}>
            <ArrowBackIcon className={classes.black} />
          </ListItemIcon>
          <ListItemText>{assetDetails?.name}</ListItemText>
        </ListItemButton>
        <ListItemButton
          className={classes.details}
          selected={tab === 'Details'}
          component={RouterLink}
          to={`/Tenants/${id}/Details`}
        >
          <ListItemIcon className={classes.itemIcon}>
            <DetailsIcon className={classes.black} />
          </ListItemIcon>
          <ListItemText>Contact Details</ListItemText>
        </ListItemButton>
        <ListItemButton
          className={classes.details}
          selected={tab === 'LeasingStrategy'}
          component={RouterLink}
          to={`/Tenants/${id}/LeasingStrategy`}
        >
          <ListItemIcon className={classes.itemIcon}>
            <FolderSpecialIcon className={classes.black} />
          </ListItemIcon>
          <ListItemText>Leasing Strategy</ListItemText>
        </ListItemButton>
        <ListItemButton
          className={classes.details}
          selected={tab === 'Options'}
          component={RouterLink}
          to={`/Tenants/${id}/Options`}
        >
          <ListItemIcon className={classes.itemIcon}>
            <ListAltIcon className={classes.black} />
          </ListItemIcon>
          <ListItemText>Break Options</ListItemText>
        </ListItemButton>
        <ListItemButton
          className={classes.details}
          selected={tab === 'ContractClauses'}
          component={RouterLink}
          to={`/Tenants/${id}/ContractClauses`}
        >
          <ListItemIcon className={classes.itemIcon}>
            <DescriptionIcon className={classes.black} />
          </ListItemIcon>
          <ListItemText>Contract Clauses</ListItemText>
        </ListItemButton>
        <ListItemButton
          className={classes.details}
          selected={tab === 'Reports'}
          component={RouterLink}
          to={`/Tenants/${id}/Reports`}
        >
          <ListItemIcon className={classes.itemIcon}>
            <ShowChartIcon className={classes.black} />
          </ListItemIcon>
          <ListItemText>Tenant Report</ListItemText>
        </ListItemButton>
      </List>
    </Drawer>
  );
};

export default TenantSidebar;
